export default {
  title: 'Обрезать изображение',
  targetSize: 'Размер после сохранения — {{width}}x{{height}}px',
  originalSize: 'Исходный размер — {{width}}x{{height}}px, {{type}} image {{size}}',
  cancel: 'Отмена',
  submit: 'Сохранить',
};
